export const ERROR = {
  101: 'INVALID_TOKEN',
  102: 'TOKEN_REQUIRED_IN_HEADER',
  103: 'SUBSCRIPTION_ID_INVALID',
  104: 'SUBSCRIPTION_ID_REQUIRED',
  105: 'NO_PERMISSION',
  106: 'LICENSE_EXPIRED',
  107: 'LICENSE_SUSPENDED',
  108: 'LICENSE_KEY_INVALID',
  109: 'LICENSE_FEATURES_NOT_DEFINED',
  110: 'LICENSE_NOT_GENUINE',
  111: 'LICENSE_GRACE_PERIOD_OVER',
  112: 'LICENSE_NOT_ACTIVATED',
  113: 'TOKEN_OR_SUBSCRIPTION_KEY_REQUIRED',
  114: 'SUBSCRIPTION_KEY_INVALID',
  115: 'LOCK_NOT_FOUND_TO_DELETE',
  116: 'LOCK_MULTIPLE_FOUND',
  117: 'ENCRYPTION_FAILED',

  401: 'FONT_FILE_MISSING',
  402: 'FONT_BOLD_ITALIC',
  403: 'FONT_ITALIC',
  404: 'FONT_BOLD',
  405: 'FONT_REGULAR',
  406: 'FILE_TYPE_REQUIRED',
  407: 'FILE_TYPE_NOT_ALLOWED',
  408: 'FONT_NAME_REQUIRED',
  409: 'FILE_REGULAR_REQUIRED',
  410: 'FILE_BOLD_REQUIRED',
  411: 'FILE_ITALIC_REQUIRED',
  412: 'FILE_BOLD_ITALIC_REQUIRED',
  413: 'FILE_IMAGE_REQUIRED',
  414: 'IMAGE_UPLOAD',
  415: 'FONT_FILE_MISSING_REQUIRED',
  416: 'KEY_FONTS_MISSING',
  417: 'SVG_FILE_TRANSLATE_ISSUE',
  418: 'PROBLEM_LOADING_FONT_FROM_FILE',
  419: 'FONT_INVALID_URL',
  420: 'INVALID_BARCODE_TYPE',
  421: 'ORGANIZATION_ID_REQUIRED',
  422: 'ORGANIZATION_STORAGE_FULL',
  423: 'INSERTS_NOT_FOUND',
  424: 'INSERTS_BEING_USED',
  425: 'INSERTS_RELATION_NOT_FOUND',
  426: 'BUSINESS_LOGIC_PRESENT_ALREADY',
  427: 'NO_BUSINESS_LOGIC_FOUND',
  428: 'NO_BUSINESS_LOGIC_FOUND_EDIT',

  501: 'TEMPLATE_VARIABLES_MISSING',
  502: 'TEMPLATE_VARIABLE_PARSING_DATE_ERROR',
  503: 'TEMPLATE_GENERATION_PAGES_LIMIT_EXCEEDED',
  504: 'TRANSACTION_LIMIT_EXCEEDED',
  551: 'TEMPLATE_NAME_UNIQUE',
  552: 'TEMPLATE_CATEGORY_NOT_EXIST',
  553: 'TEMPLATE_SHARE_TYPE_ALLOWED_VALUES',
  554: 'TEMPLATE_PRINT_TEST_FAILS',
  555: 'TEMPLATE_VARIABLE_NAME_NULL',
  556: 'TEMPLATE_VARIABLE_MAX_LENGTH_NULL',
  557: 'TEMPLATE_ID_NOT_NULL',
  558: 'TEMPLATE_ID_NOT_INTEGER',
  559: 'TEMPLATE_ID_NOT_EXIST',
  560: 'TEMPLATE_FONT_NOT_EXIST',
  561: 'TEMPLATE_ELEMENT_RENDER_ERROR',
  562: 'TEMPLATE_LOCKING_ERROR',
  563: 'TEMPLATE_CLIENT_EDIT_MASTER',
  564: 'TEMPLATE_MASTER_EDIT_PUBLISH_STATUS',
  565: 'PUBLISHER_ROLE_REQUIRED',
  566: 'TEMPLATE_USED_AS_ATTACHMENT',
  567: 'PAGE_ID_NOT_NULL',
  568: 'TARGET_LANGUAGE_NOT_NULL',
  571: 'PUBLISHED_ID_AND_TEMPLATE_ID_NULL',
  572: 'PUBLISHED_ID_NOT_EXIST',
  573: 'ACTIVE_PUBLISHED_TEMPLATE_ID_NOT_EXIST',
  574: 'PUBLISH_ID_REQUIRED',
  575: 'STATUS_PARAM_REQUIRED',
  576: 'MASTER_ACCESSING_USER_TEMPLATE',
  577: 'MASTER_LOCKING_USER_TEMPLATE',
  578: 'CLIENT_LOCKING_MASTER_TEMPLATE',
  581: 'TEMPLATE_ALREADY_TRANSLATED',
  582: 'MASTER_CANNOT_TRANSLATE_CLIENT_TEMPLATE',
  583: 'CLIENT_CANNOT_TRANSLATE_MASTER_TEMPLATE',
  584: 'MASTER_TEMPLATE_CANNOT_BE_TRANSLATED',
  585: 'PROCESSED_PDF_STORAGE_SHOULD_NOT_BE_LOCAL',
  586: 'QA_READY_ID_AND_TEMPLATE_ID_NULL',
  587: 'QA_READY_ID_NOT_EXIST',
  588: 'ACTIVE_QA_READY_ID_NOT_EXIST',
  589: 'ONLY_ACTIVE_REFERENCED_ELEMENT_ALLOWED',
  590: 'INVALID_ACROFORM_FIELD_NAMES',
  591: 'FAILED_TO_FETCH_TEMPLATE',

  601: 'CATEGORY_NAME_UNIQUE',
  602: 'CATEGORY_TYPE_ALLOWED_VALUES',
  603: 'CATEGORY_ID_NOT_NULL',
  604: 'CATEGORY_ID_NOT_INTEGER',
  605: 'CATEGORY_ID_NOT_EXIST',
  606: 'CATEGORY_NAME_LENGTH',
  607: 'INVALID_CATEGORY_TYPE',
  608: 'INVALID_USER_TYPE',
  609: 'INVALID_FORMAT',
  610: 'INVALID_ACCESS_TYPE',
  611: 'INVALID_TEMPLATE_STATUS',
  612: 'INVALID_ENV_TYPE',
  613: 'INVALID_CHANNEL_TYPE',
  614: 'INVALID_LOCK_TYPE',
  615: 'ORGANIZATION_ID_OF_USER_NOT_SAME_AS_CATEGORY',
  616: 'FAILED_TO_GET_CATEGORY_IDS',
  701: 'FOLDER_NAME_UNIQUE',
  702: 'FOLDER_ID_NOT_NULL',
  703: 'FOLDER_ID_NOT_INTEGER',
  704: 'FOLDER_ID_NOT_EXIST',
  705: 'FOLDER_PARENT_ID_NOT_EXIST',
  706: 'FOLDER_ELEMENT_TYPE_ALLOWED_VALUES',
  707: 'FOLDER_ELEMENT_ID_NOT_NULL',
  708: 'FOLDER_ELEMENT_ID_NOT_EXIST',
  709: 'FOLDER_ELEMENT_ID_NOT_NULL_2',
  710: 'FOLDER_ELEMENT_HAVING_ID_NOT_EXIST',
  711: 'FOLDER_ELEMENT_ID_NOT_INTEGER',
  713: 'FOLDER_NAME_LENGTH',
  714: 'INVALID_FOLDER_TYPE',
  721: 'EFAX_CUSTOMER_KEY_UNIQUE',
  722: 'EFAX_CUSTOMER_KEY_NULL',
  723: 'EFAX_ERROR_FETCHING_USER_INFO',
  731: 'EFAX_USER_NAME',
  750: 'FAILED_TO_GET_RESOURCE_GROUP_IDS',
  751: 'ELEMENT_NAME_UNIQUE',
  752: 'ELEMENT_NAME_LENGTH',
  753: 'REFERENCED_ELEMENT_IS_USED',
  754: 'INVALID_ELEMENT_TYPE',
  755: 'INVALID_FROM',
  756: 'INVALID_REFERENCED',
  757: 'INVALID_RG_PERMISSION',
  758: 'INVALID_STATUS',
  759: 'INVALID_QA_READY_STATUS',
  760: 'INVALID_RESPONSE_TYPE',
  761: 'RESPONSE_TYPE',
  762: 'BARCODE_VARIABLE_NULL',
  763: 'INVALID_HTML_RESOURCE_TYPE',
  764: 'INVALID_ATTACHMENT_RESOURCE_TYPE',
  765: 'INVALID_RESOURCE_TYPE',
  766: 'INVALID_ATTACHMENT_PASSWORD',
  767: 'ELEMENT_DOES_NOT_EXIST',
  791: 'RESOURCE_GROUP_UNIQUE',
  792: 'RESOURCE_GROUP_NAME_LENGTH',
  793: 'RESOURCE_GROUP_NOT_NULL',
  794: 'RESOURCE_GROUP_ID_NOT_EXIST',
  795: 'RESOURCE_GROUP_CAN_NOT_BE_DELETED',
  796: 'FAILED_TO_ADD_RESOURCE_GROUP',
  797: 'FAILED_TO_UPDATE_RESOURCE_GROUP',
  798: 'FAILED_TO_DELETE_RESOURCE_GROUP',
  799: 'FAILED_TO_GET_RESOURCE_GROUP',
  800: 'FAILED_TO_GET_RESOURCE_GROUP_PERMISSION',

  801: 'INVALID_CREDENTIALS',
  802: 'EMAIL_INVALID',
  803: 'EMAIL_ALREADY_EXIST',
  804: 'FIRST_NAME_NULL',
  825: 'CHARACTER_COUNT_ERROR',
  823: 'LAST_NAME_NULL',
  805: 'EMAIL_NULL',
  806: 'USER_TYPE_NULL',
  807: 'USER_TYPE_VALUE_NOT_ALLOWED',
  808: 'ROLES_NULL',
  809: 'ROLES_INVALID',
  810: 'USER_NOT_EXIST',
  811: 'USER_ID_NULL',
  812: 'ROLE_ID_NOT_AVAILABLE',
  813: 'PERMISSION_IDS_NOT_AVAILABLE',
  814: 'PERMISSION_IDS_ACTION_NOT_NULL',
  816: 'RESOURCE_GROUP_PERMISSION_MANDATORY',
  817: 'SET_PASSWORD_LINK_EXPIRED',
  818: 'SET_PASSWORD_LINK_FORGED',
  819: 'SET_PASSWORD_DOES_NOT_EXIST',
  820: 'ACTIVE_DIRECTORY_UNIQUE_ID_REQUIRED',
  821: 'USER_NOT_ADDED_IN_DOCSTUDIO_APP',
  822: 'AD_USER_ALREADY_ADDED_TO_DOCSTUDIO',
  901: 'INVALID_CREDENTIALS_2',
  902: 'NO_SUCH_PROVIDER',
  903: 'MESSAGING_EXCEPTION',
  904: 'SMTP_SERVER_CONFIG_NOT_FOUND',
  905: 'JMS_EXCEPTION',
  906: 'IO_EXCEPTION',
  907: 'TEMPLATE_EXCEPTION',
  908: 'EXCEPTION',
  909: 'VARIABLE_NAME_EXIST',
  910: 'VARIABLE_DELETE_FAILS',
  911: 'VARIABLE_REFERENCE_ADD_FAILS',
  912: 'VARIABLE_CATEGORY_NAME_EXIST',
  913: 'VARIABLE_CATEGORY_DELETE_FAILS',
  914: 'TEMPLATE_NAME_EXIST',
  915: 'AUTHENTICATION_ERROR',
  916: 'TEMPLATE_ERROR',
  917: 'TEMPLATE_ERROR_2',
  918: 'TEMPLATE_ERROR_3',
  919: 'SMTP_SERVER_CONFIG_NAME_EXIST',
  920: 'DELETE_SMTP_SERVER_CONFIG_FAILS',
  921: 'BAD_REQUEST',
  922: 'ELEMENT_NAME_EXISTS',
  923: 'INVALID_MAIL_TEMPLATE_ID',
  924: 'INVALID_TO_ADDRESS',
  925: 'INVALID_CC_ADDRESS',
  926: 'INVALID_BCC_ADDRESS',
  927: 'DEFAULT_SMTP_NOT_FOUND',
  928: 'TEMPLATE_MOVED_TO_QA_ERROR',
  929: 'TEMPLATE_MOVED_TO_QA_ERROR_2',
  930: 'TEMPLATE_APPROVED_ERROR',
  931: 'TEMPLATE_PUBLISH_ERROR',
  932: 'TAG_NAME_EXIST',
  933: 'PRINTER_CONFIGURATION_INVALID',
  934: 'INVALID_TAG_ID',
  935: 'ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE_CATEGORY',
  936: 'ORGANIZATION_ID_OF_USER_NOT_MATCHED_WITH_VARIABLE',
  937: 'DELETE_SMTP_SERVER_CONFIG_FAILS_2',
  938: 'VARIABLE_IS_IN_USE',
  940: 'JSON_PROCESSING_ERROR',
  941: 'INVALID_BATCH_ID',
  942: 'INVALID_FROM_ADDRESS',
  950: 'ORGANIZATION_NOT_FOUND',

  1000: 'DYNAMIC_FILLABLE_ERROR',
  1001: 'MESSAGE_NAME_UNIQUE',
  1002: 'MESSAGE_ID_NOT_NULL',
  1003: 'MESSAGE_ID_NOT_EXIST',
  1004: 'MESSAGE_NO_CONTENT_FOR_ACTION',
  1005: 'MESSAGE_VARIABLES_MISSING',
  1006: 'MESSAGE_VOICE_NOT_AVAILABLE',

  1101: 'INVALID_DATE_RANGE',
  1111: 'INVALID_DASHBOARD_REQUEST',

  1201: 'INVALID_PRINTER_IP_ADDRESS_REACHABLE',
  1202: 'INVALID_PRINTER_IP_ADDRESS_EXISTS',
  1203: 'INVALID_PRINTER_NAME_EXISTS',
  1204: 'INVALID_CUPS_HOSTNAME_REQUIRED',
  1205: 'INVALID_CUPS_PORT_REQUIRED',
  1206: 'INVALID_CUPS_USERNAME_REQUIRED',
  1207: 'INVALID_CUPS_PASSWORD_REQUIRED',
  1208: 'INVALID_PRINTER_ID_NOT_EXIST',
  1209: 'INVALID_PRINTER_ID_REQUIRED',
  1210: 'UNABLE_TO_DELETE_PRINTER_ACTIVE_JOBS',
  1211: 'DOCUMENT_ALREADY_IN_OTHER_BATCH',
  1212: 'NO_DOCUMENTS_FOUND',
  1213: 'UNABLE_TO_FETCH_CUPS_DETAILS',
  1214: 'INVALID_PRINTER_CONFIGURATION',
  1215: 'INVALID_PRINTER_IP_ADDRESS',
  1216: 'CUPS_CLIENT_FAILED',
  1217: 'INVALID_DATE',
  1218: 'BATCH_NAME_ALREADY_EXISTS',
  1219: 'UNABLE_TO_DELETE_PRINTER',
  1220: 'UNABLE_TO_DELETE_PRINTER_SUBSCRIPTION_FAILED',
  1221: 'UNABLE_TO_DELETE_PRINTER_ONE_REQUIRED',
  1222: 'INVALID_PRINTER_NAME_LENGTH',
  1223: 'INVALID_PRINTER_NAME_MANDATORY',
  1224: 'UNABLE_TO_ADD_PRINTER',
  1225: 'INVALID_DATE_RANGE_2',

  1301: 'ACCOUNTSID_MANDATORY',
  1302: 'AUTHTOKEN_MANDATORY',
  1303: 'FROMNUMBER_MANDATORY',
  1304: 'INVALID_TWILIO_CREDENTIALS',
  1305: 'FROM_SMS_NUMBER_NOT_ASSOCIATED',
  1306: 'FROM_WHATSAPP_NUMBER_NOT_ASSOCIATED',
  1307: 'TWILIO_CONFIG_ALREADY_EXISTS',
  1308: 'FROM_CALL_NUMBER_NOT_ASSOCIATED',
  1309: 'GOOGLE_CONFIG_ALREADY_EXISTS',

  1401: 'CONTACT_PREFERRED_METHOD_INVALID',
  1402: 'MULTIPLE_PRIMARY_ADDRESS',
  1403: 'ADDRESS_CITY_STATE_COUNTRY_NULL',
  1404: 'ADDRESS_CITY_STATE_COUNTRY_INVALID',
  1405: 'MULTIPLE_PRIMARY_EMAIL',
  1406: 'EMAIL_CANNOT_BE_NULL',
  1407: 'DUPLICATE_EMAIL_FOR_CONTACT',
  1408: 'MULTIPLE_PRIMARY_NUMBER',
  1409: 'NUMBER_CANNOT_BE_NULL',
  1410: 'DUPLICATE_NUMBER_FOR_CONTACT',
  1411: 'RESOURCE_GROUP_CANNOT_BE_NULL',
  1412: 'USER_NO_WRITE_PERMISSION_FOR_TEAM',
  1413: 'FIRST_OR_LAST_NAME_MANDATORY',

  1501: 'FAILED_TO_FETCH_USER_DETAILS',
  1502: 'FAILED_TO_ADD_USER',
  1503: 'FAILED_TO_INVITE_USER',
  1504: 'INVALID_RESOURCE_GROUP_ID',
  1505: 'FAILED_TO_UPDATE_USER',
  1506: 'USER_EMAIL_CANNOT_BE_UPDATED',
  1507: 'FAILED_TO_DELETE_USER',
  1508: 'UNABLE_TO_UPDATE_DELETED_USER',
  1509: 'ADD_USER_RATE_LIMIT_EXCEEDED',
  1510: 'PRIMARY_USER_CANNOT_BE_DELETED',
  1511: 'FAILED_TO_FETCH_API_KEY',
  1512: 'FAILED_TO_CREATE_API_KEY',
  1513: 'PRIMARY_USER_ADMIN_ROLE_CANNOT_BE_CHANGED',
  1514: 'ORGANIZATION_USER_SIGNUP_ERROR',

  1601: 'ORGANIZATION_NOT_FOUND',
  1602: 'ORGANIZATION_INACTIVE',
  1603: 'USER_ROLE_MISMATCH',
  1604: 'INVALID_ORGANIZATION_SUBSCRIPTION_ID',
  1605: 'UNKNOWN_PRODUCT_PRICING',
  1606: 'UNKNOWN_PRICING_TABLE',
  1607: 'UNKNOWN_ERROR',

  1701: 'TEAM_LIMIT_EXCEEDED',
  1702: 'TRANSLATION_LIMIT_EXCEEDED',
  1703: 'PLAN_NOT_ACTIVE',
  1704: 'FROM_ADDRESS_LIMIT',
  1705: 'FROM_ADDRESS_LIMIT_REACHED',

  1801: 'AI_TEXT_GENERATION_FAILED',

  1901: 'GET_TEMPLATE_NAME_FAILED',
  1902: 'FETCH_GENERATED_FILE_FAILED',
  1903: 'DELETE_GENERATED_FILE_FAILED',

  2000: 'FAILED_TO_GET_USER',
  2001: 'FAILED_TO_GET_LANGUAGE_COUNT',
  2002: 'FAILED_TO_GET_TEXT_GENERATION_COUNT',
  2003: 'FAILED_TO_GET_TRANSLATION_COUNT',
  2004: 'FAILED_TO_GET_CLOUD_STORAGE_METRICS',
  2005: 'FAILED_TO_GET_DOCUMENT_PAGES',
  2006: 'FAILED_TO_GET_DOCUMENTS_COUNT',
  2007: 'FAILED_TO_GET_EMAIL_TRANSACTION_COUNT',

  2100: 'ADDRESS_NOT_EXIST',
  2101: 'ADDRESS_ALREADY_EXIST',
  2102: 'SPARKPOST_RESPONSE_BODY_NULL',
  2103: 'SPARKPOST_REQUEST_FAILS',
  2104: 'EXCEPTION_OCCURRED',
  2105: 'SPARKPOST_CLIENT_ERROR',
  2106: 'DOMAIN_NOT_EXIST',
  2107: 'DELETE_FROM_ADDRESS_FAILS',
  2108: 'DEFAULT_DOMAIN_ADD_FROM_ADDRESS_FAILS',
  2109: 'DOMAIN_ALREADY_ASSOCIATED',
  2110: 'DOMAIN_ASSOCIATES_WITH_FROM_ADDRESS',
  2111: 'FROM_ADDRESS_ID_NOT_NULL',

  2200: 'MULTIPLE_TO_ADDRESS_NOT_ALLOWED',
  2201: 'PLAN_TRANSACTION_LIMIT_EXCEEDED',
  2202: 'ATTACHMENT_PASSWORD_INVALID',
  2203: 'EMAIL_BULK_REQUEST_INVALID',

  2300: 'DOCUMENT_ID_CANNOT_BE_NULL',
  2301: 'BUSINESS_LOGIC_NAME_CANNOT_BE_NULL',
  2302: 'BUSINESS_LOGIC_WITH_NAME_ALREADY_EXIST',
  2303: 'DOCUMENT_ID_NOT_EXIST',
  2304: 'BUSINESS_LOGIC_NOT_EXIST',
  2305: 'BUSINESS_LOGIC_ID_CANNOT_BE_NULL',

  2350: 'ID_CANNOT_BE_NULL',
  2351: 'BLOCK_NOT_EXIST',
  2352: 'FLOW_NOT_EXIST',
  2353: 'DOCUMENT_NOT_EXIST',
  2354: 'EMAIL_NOT_EXIST',
  2355: 'EMAIL_BLOCK_NOT_EXIST',

  2401: 'FAILED_TO_DELETE_DOCUMENT',
  2402: 'FAILED_TO_DELETE_QA_OR_PUBLISH_DOCUMENT',
  2404: 'FAILED_TO_SET_FILTERS',
  2405: 'FAILED_TO_FETCH_DOCUMENT',
  2406: 'FAILED_TO_APPLY_FILTERS',
  2408: 'FETCH_TRANSACTION_TIMESTAMP_FAILURE',
  2409: 'DOCUMENT_NAME_UNIQUE',
  2410: 'FAILED_TO_FETCH_QA_DOCUMENT',
  2411: 'FAILED_TO_FETCH_PUBLISHED_DOCUMENT',
  2415: 'NO_DOCUMENT_FOUND',
  2420: 'UNABLE_TO_DETECT_LANGUAGE',
  2421: 'LANGUAGE_NOT_DETECTED_FOR_CONTENT',
  2422: 'DOCUMENT_COUNT_EXCEEDED',
  2423: 'FAILED_TO_FETCH_PUBLISHED_EMAIL',
  2424: 'FAILED_TO_FETCH_EMAIL',
  2425: 'FAILED_TO_PARSE_DOCUMENT',
  2426: 'SANITIZATION_ERROR',
  2427: 'FAILED_TO_GET_TRANSCRIPT',

  2451: 'FAILED_TO_FETCH_PLAN_CYCLE',
  2452: 'FAILED_TO_FETCH_CHARS_TRANSLATED',
  2453: 'STANDALONE_FLOW_ALREADY_TRANSLATED',
  2500: 'BLOCK_NAME_UNIQUE',
  2501: 'STANDALONE_BLOCK_IS_IN_USE',
  2502: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_BLOCK',
  2503: 'NO_QA_READY_REFERENCE_FOR_STANDALONE_BLOCK',
  2504: 'NO_QA_COMPLETE_REFERENCE_FOR_STANDALONE_BLOCK',
  2505: 'INVALID_PARAMETERS',
  2650: 'STANDALONE_FLOW_CREATION_FAILED',
  2651: 'FLOW_NAME_UNIQUE',
  2652: 'STANDALONE_FLOW_NOT_EXISTS',
  2653: 'STANDALONE_FLOW_IS_IN_USE',
  2654: 'FLOW_AND_BLOCK_MAPPING_FAILED',
  2655: 'STANDALONE_FLOW_CANNOT_BE_TOC',
  2656: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_STANDALONE_FLOW',
  2657: 'FLOW_CONTENT_IS_BLANK',
  2600: 'DOCUMENT_ID_CANNOT_BE_NULL',
  2601: 'PARSE_EXCEPTION',
  2602: 'DOCUMENT_NOT_FOUND',
  2603: 'INVALID_PUBLISH_STATUS',
  2604: 'INVALID_DOCUMENT_ID',
  2605: 'DOCUMENT_GENERATION_FAILURE',
  2606: 'DOCUMENT_ZIP_FAILURE',
  2607: 'GET_PDF_TRANSACTION_COUNT_FAILURE',
  2608: 'VARIABLE_VALIDATION_FAILURE',
  2609: 'FAILED_TO_SYNC_VARIABLE',
  2610: 'NAME_CANNOT_BE_EMPTY',
  2611: 'CREDENTIALS_CANNOT_BE_EMPTY',
  2612: 'BUCKET_OR_CDN_CREATION_FAILURE',
  2613: 'SET_ORG_STORAGE_FAILURE',
  2614: 'SECRET_OR_ACCESS_KEY_EMPTY',
  2700: 'ID_CANNOT_BE_NULL',
  2701: 'LANGUAGE_CANNOT_BE_UPDATED',
  2702: 'LANGUAGE_CANNOT_BE_NULL',
  2703: 'LANGUAGE_NOT_SUBSCRIBED',
  2800: 'RESOURCE_TYPE_CANNOT_BE_NULL',
  2801: 'RESOURCE_ID_CANNOT_BE_NULL',
  2900: 'EMAIL_ID_CANNOT_BE_NULL',
  2901: 'BUSINESS_LOGIC_NAME_CANNOT_BE_NULL',
  2902: 'BUSINESS_LOGIC_WITH_NAME_ALREADY_EXIST',
  2903: 'EMAIL_TEMPLATE_ID_NOT_EXIST',
  2904: 'EMAIL_BUSINESS_LOGIC_NOT_EXIST',
  2905: 'EMAIL_BUSINESS_LOGIC_ID_CANNOT_BE_NULL',
  2906: 'FAILED_TO_DELETE_QA_OR_PUBLISHED_EMAIL_TEMPLATE',
  2907: 'SMTP_RETRY_COUNT_ERROR',
  2951: 'MISSING_SOURCE_OR_TARGET_TEAM',
  2952: 'VARIABLE_CATEGORY_NOT_EXISTS',
  3000: 'DOCUMENT_LINKED_TO_OTHER_CHANNEL',
  3001: 'EMAIL_LINKED_TO_OTHER_CHANNEL',
  3002: 'SHORT_MESSAGE_LINKED_TO_OTHER_CHANNEL',
  3003: 'COMMUNICATION_NAME_ALREADY_EXISTS',
  3100: 'VARIABLE_VALUE_CHECK',
  3101: 'MANDATORY_FIELD_CHECK',
  3102: 'MAX_VALUE_CHECK',
  3103: 'INVALID_DATE_FORMAT',
  3104: 'CHART_VALUE_SHOULD_BE_NUMBER',
  3105: 'CHART_DATA_PROCESSING_ERROR',
  3106: 'BARCODE_VALUE_ERROR',
  3107: 'INVALID_HTML_ERROR',
  3108: 'UNABLE_TO_PROCESS_HTML_PAYLOAD',
  4001: 'FAILED_GENERATE_TOKEN',
  4002: 'FAILED_FETCHING_JOB',
  4003: 'BATCH_STATUS_ERROR',
  4004: 'PROCESS_INCOMPLETE',
  4005: 'NO_SUCCESS_RECORDS',
  4006: 'JOB_ID_CANNOT_BE_NULL',
  4007: 'SORT_VALUES_EMPTY',
  5000: 'INTERNAL_SERVER_ERROR',
  5001: 'REQUEST_EMPTY',
  5002: 'INTERNAL_SERVER_ERROR',
  5003: 'BATCH_NOT_EXIST',
  5004: 'APPROVER_NOT_EXIST',
  5005: 'METADATA_CREATION_ERROR',
  5006: 'COMMUNICATION_ID_MISSING',
  5007: 'PUBLISHED_ON_DOC_ID_NOT_EXISTS',
  5008: 'QA_ON_DOC_ID_NOT_EXISTS',
  5009: 'COMMUNICATION_ON_COM_ID_NOT_EXISTS',
  5010: 'PUBLISHED_ON_COM_ID_NOT_EXISTS',
  5011: 'QA_ON_COM_ID_NOT_EXISTS',
  5021: 'DOC_GENERATION_RATE_LIMIT_EXCEEDED',
  5023: 'DATA_SET_VALIDATION_ERROR',
  5012: 'PUBLISHED_DOC_FETCH_FAILS',
  5013: 'QA_DOC_FETCH_FAILS',
  5014: 'PUBLISHED_DOC_DESIGN_FLOW_ERROR',
  5015: 'QA_DOC_DESIGN_FLOW_ERROR',
  5016: 'PUBLISHED_DOC_VARIABLE_CONTRACT_ERROR',
  5017: 'QA_DOC_VARIABLE_CONTRACT_ERROR',
  5018: 'DOC_GENERATION_FAILS',
  5019: 'PDF_STORAGE_ERROR',
  5020: 'BATCH_REQUEST_ERROR',
  5022: 'CONSUMER_FAILS',
  5024: 'BATCH_REQUEST_PROCESSING_ERROR',
  5025: 'BATCH_REQUEST_PERSIST_ERROR',
  5026: 'MAIL_TEMPLATE_ID_MISSING',
  5027: 'LANGUAGE_MISSING',
  5028: 'RECIPIENT_ADDRESS_MISSING',
  5029: 'PUBLISHED_ON_EMAIL_ID_NOT_EXISTS',
  5030: 'PUBLISHED_EMAIL_FETCH_FAILS',
  5031: 'SMTP_RETRY_REACHED',
  5032: 'PUBLISHED_EMAIL_DESIGN_FLOW_ERROR',
  5033: 'PUBLISHED_EMAIL_VARIABLE_CONTRACT_ERROR',
  5034: 'FILE_ATTACHMENT_ERROR',
  5035: 'DOC_ATTACHMENT_ERROR',
  5036: 'CREATIVE_BLOCK_IMAGE_ERROR',
  5037: 'TEMPLATE_TO_HTML_ERROR',
  5038: 'RETRY_SEND_EMAIL_ERROR',
  5039: 'SEND_EMAIL_ERROR',
  5040: 'SMTP_CONFIG_FETCH_ERROR',
  5041: 'EMAIL_GENERATION_RATE_LIMIT_EXCEEDED',
  5042: 'VALIDATE_REQUEST_FAILED',
  5043: 'ACCOUNT_EMAIL_USAGE_FAILED',
  5044: 'PREPARE_PUBLISHED_EMAIL_FLOW_ERROR',
  5045: 'QA_EMAIL_FETCH_FAILS',
  5046: 'QA_ON_EMAIL_NOT_EXISTS',
  5047: 'PREPARE_QA_EMAIL_FLOW_ERROR',
  5048: 'QA_EMAIL_VARIABLE_CONTRACT_ERROR',
  5049: 'QA_EMAIL_DESIGN_FLOW_ERROR',
  5050: 'API_RATE_LIMIT_ERROR',
  5051: 'BATCH_REQUEST_QUEUE_ERROR',
  5052: 'BATCH_REQUEST_PERSIST_ERROR',
  5100: 'FAILED_TO_CREATE_SSO_CONNECTION',
  5101: 'FAILED_TO_SAVE_SSO_CONNECTION',
  5102: 'FAILED_TO_GET_SSO_CONNECTION',
  5103: 'SSO_CONNECTION_NOT_EXIST',
  5104: 'FAILED_TO_SWITCH_SSO_CONFIG',
  5105: 'FAILED_TO_SAVE_DIRECTORY_SYNC',
  5106: 'FAILED_TO_CREATE_DIRECTORY_SYNC',
  5107: 'FAILED_TO_GET_SSO_CONNECTION',
  5108: 'NO_RECORDS_FOUND',
  5109: 'EXTERNAL_PRINT_CONFIG_NOT_FOUND',
  5110: 'EXTERNAL_PRINT_CONFIG_NOT_VALID',
  5111: 'FAILED_TO_SEND_PRINT',
  5112: 'FAILED_TO_UPDATE_PRINTING_CONFIG',
  5113: 'FAILED_TO_UPDATE_PRINT_STATUS',
  5114: 'PRINT_REQUEST_RECORD_NOT_FOUND',
  5115: 'UNABLE_TO_UPDATE_PRINT_STATUS',
  5116: 'BATCH_ENDED',
  5200: 'GET_TEAM_FAILED_BY_QUERY',
  5201: 'GET_TEAM_FAILED_UNEXPECTEDLY',
  5300: 'GET_PRINT_BATCH_ERROR',
  9999: 'DOCSTUDIO_UNKNOWN_ERROR'
};
